import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    parameters: null,
    isFetched: null,
    isFetchedCategoryAttributes: true,
    categoryAttributeWithValues: null,
    isExportingInProcess: false,
    ozonTasks: [],
    isFetchedOzonTasks: false,
    productImportInfo: null,
    isFetchedProductImportInfo: false,
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    async getOzonTasks({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isFetchedOzonTasks", value: false });
      return axios
        .get(this._vm.$apiURL + "/ozon_seller_api_tasks")
        .then((response) => {
          updateField(state, {
            path: "ozonTasks",
            value: response.data.data,
          });
          return response.data.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "isFetchedOzonTasks", value: true });
        });
    },

    async getTaskImportInfo({ commit, state, dispatch }, payload) {
      updateField(state, { path: "productImportInfo", value: null });
      updateField(state, { path: "isFetchedProductImportInfo", value: false });
      return axios
        .get(
          this._vm.$apiURL +
            "/ozon_seller_api?method=productImportInfo&task_id=" +
            payload
        )
        .then((response) => {
          updateField(state, {
            path: "productImportInfo",
            value: response.data,
          });

          return response.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, {
            path: "isFetchedProductImportInfo",
            value: true,
          });
        });
    },
    async startExport({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isExportingInProcess", value: true });
      return axios
        .get(this._vm.$apiURL + "/ozon_seller_api?method=productImport")
        .then((response) => {
          dispatch('getOzonTasks');
          return response.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, {
            path: "isExportingInProcess",
            value: false,
          });
        });
    },
    async getCategoryAttributes({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isFetchedCategoryAttributes", value: false });
      updateField(state, { path: "categoryAttributeWithValues", value: null });
      return axios
        .get(
          this._vm.$apiURL +
            "/ozon_seller_api?method=categoryAttributeWithValues&category_id=" +
            payload.category_id
        )
        .then((response) => {
          updateField(state, {
            path: "categoryAttributeWithValues",
            value: response.data.attributes,
          });
          return response.data.attributes;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, {
            path: "isFetchedCategoryAttributes",
            value: true,
          });
        });
    },
    async getParameters({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isFetched", value: false });
      return axios
        .get(this._vm.$apiURL + "/ozon_seller_api_parameters")
        .then((response) => {
          updateField(state, {
            path: "parameters",
            value: response.data.data,
          });
          return response.data.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "isFetched", value: true });
        });
    },
    async updateParameters({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isFetched", value: false });
      return axios
        .put(this._vm.$apiURL + "/ozon_seller_api_parameters", payload)
        .then((response) => {
          updateField(state, {
            path: "parameters",
            value: response.data.data,
          });
          this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          return response.data.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "isFetched", value: true });
        });
    },
  },
};
